import React from 'react';
import { MessageSquareIcon, MessageCircleIcon, MailIcon, PhoneIcon, BrainIcon, BookOpenIcon, SearchIcon } from 'lucide-react';
const Slide2 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2586">
      <div className="flex flex-col space-y-6" data-id="element-2587">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-6" data-id="element-2588">
          Meet shoppers where they are
        </h2>
        {/* New Taxonomy Section */}
        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200 mb-4" data-id="element-2589">
          <h3 className="font-semibold text-blue-800 mb-2 flex items-center" data-id="element-2590">
            <BrainIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-2591" />
            New Taxonomy Hidden Layer
          </h3>
          <p className="text-gray-700 text-sm" data-id="element-2592">
            We're developing a new taxonomy hidden layer that enables natural
            conversations across all channels. This semantic layer understands
            product relationships, attributes, and customer needs to provide
            consistent, intelligent responses.
          </p>
        </div>
        {/* Channels */}
        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-2593">
          {['Website', 'Messenger', 'Comments', 'WhatsApp', 'Telegram', 'Email'].map(channel => <span key={channel} className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2594">
              {channel}
            </span>)}
        </div>
        {/* Subtitle */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 max-w-3xl mx-auto mb-8" data-id="element-2595">
          <h3 className="font-semibold text-amber-800 mb-2" data-id="element-2596">
            For Sonae MC's Brands:
          </h3>
          <ul className="text-gray-700 space-y-2" data-id="element-2597">
            <li className="flex items-center gap-2" data-id="element-2598">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2599"></div>
              <span data-id="element-2600">Continente — hyper/super markets</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-2601">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2602"></div>
              <span data-id="element-2603">Modelo — medium-sized</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-2604">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2605"></div>
              <span data-id="element-2606">Bom Dia — convenience</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-2607">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2608"></div>
              <span data-id="element-2609">Online — e-commerce & delivery</span>
            </li>
          </ul>
        </div>
        {/* Knowledge Base Section */}
        <div className="bg-green-50 rounded-lg p-5 border border-green-200 mb-6" data-id="element-2610">
          <div className="flex items-start gap-4" data-id="element-2611">
            <div className="bg-green-100 rounded-full p-3 flex-shrink-0" data-id="element-2612">
              <BookOpenIcon className="h-6 w-6 text-green-600" data-id="element-2613" />
            </div>
            <div data-id="element-2614">
              <h3 className="text-lg font-semibold text-green-800 mb-2" data-id="element-2615">
                Knowledge Base
              </h3>
              <p className="text-gray-700 mb-3" data-id="element-2616">
                Our comprehensive knowledge base powers all customer
                interactions with:
              </p>
              <ul className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3" data-id="element-2617">
                <li className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2618">
                  <h4 className="font-medium text-green-700 mb-1 flex items-center" data-id="element-2619">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-2620"></div>
                    Product Advice
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2621">
                    Personalized recommendations based on customer needs and
                    preferences
                  </p>
                </li>
                <li className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2622">
                  <h4 className="font-medium text-green-700 mb-1 flex items-center" data-id="element-2623">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-2624"></div>
                    Product Features
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2625">
                    Detailed specifications and unique selling points for all
                    catalog items
                  </p>
                </li>
                <li className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2626">
                  <h4 className="font-medium text-green-700 mb-1 flex items-center" data-id="element-2627">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-2628"></div>
                    Customer Questions
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2629">
                    Instant answers to common queries about policies,
                    availability, and more
                  </p>
                </li>
              </ul>
              <p className="text-sm text-gray-700" data-id="element-2630">
                Empowers both online shoppers and offline store representatives
                with consistent, accurate information.
              </p>
            </div>
          </div>
        </div>
        {/* Visualization - Simplified */}
        <div className="mt-4 max-w-4xl mx-auto" data-id="element-2631">
          <div className="grid grid-cols-2 gap-8 py-6" data-id="element-2632">
            <div className="flex justify-end" data-id="element-2633">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2634">
                <div className="flex items-center gap-3 mb-2" data-id="element-2635">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2636">
                    <MessageSquareIcon className="h-5 w-5 text-indigo-600" data-id="element-2637" />
                  </div>
                  <h3 className="font-medium" data-id="element-2638">Website Chat</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2639">
                  Embedded on all product pages and checkout
                </p>
              </div>
            </div>
            <div data-id="element-2640">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2641">
                <div className="flex items-center gap-3 mb-2" data-id="element-2642">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2643">
                    <MessageCircleIcon className="h-5 w-5 text-indigo-600" data-id="element-2644" />
                  </div>
                  <h3 className="font-medium" data-id="element-2645">Social Media</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2646">
                  Messenger, Comments, and DMs
                </p>
              </div>
            </div>
            <div className="flex justify-end" data-id="element-2647">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2648">
                <div className="flex items-center gap-3 mb-2" data-id="element-2649">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2650">
                    <PhoneIcon className="h-5 w-5 text-indigo-600" data-id="element-2651" />
                  </div>
                  <h3 className="font-medium" data-id="element-2652">WhatsApp</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2653">
                  Direct messaging for customers on the go
                </p>
              </div>
            </div>
            <div data-id="element-2654">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2655">
                <div className="flex items-center gap-3 mb-2" data-id="element-2656">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2657">
                    <MailIcon className="h-5 w-5 text-indigo-600" data-id="element-2658" />
                  </div>
                  <h3 className="font-medium" data-id="element-2659">Email</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2660">
                  Personalized recommendations and follow-ups
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Knowledge Base Search Example */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 max-w-md mx-auto" data-id="element-2661">
          <div className="flex items-center gap-2 mb-3" data-id="element-2662">
            <SearchIcon className="h-5 w-5 text-gray-500" data-id="element-2663" />
            <input type="text" placeholder="Search knowledge base..." className="w-full border border-gray-200 rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" defaultValue="Continente product features" data-id="element-2664" />
          </div>
          <div className="p-3 border border-indigo-200 rounded-lg bg-indigo-50" data-id="element-2665">
            <h4 className="font-medium text-indigo-800 mb-1" data-id="element-2666">
              Smart Knowledge Retrieval
            </h4>
            <p className="text-sm text-gray-700" data-id="element-2667">
              The same knowledge powers all channels, ensuring consistent
              answers whether customers interact via chat, WhatsApp, or with
              in-store staff.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide2;